/**
 * Generate a random ID.
 *
 * NOTE: This does NOT guarantee a unique ID. Just a random
 * ID suitable for id's on things like div's etc. Also NOT
 * suitable for key props as it returns a different ID
 * each time.
 */
export default function generateRandomId() {
    var S4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
}
//# sourceMappingURL=index.js.map